import { Link } from "@tanstack/react-router";

export function TagChips({
  tags,
  size = "sm",
}: {
  tags: Array<{ slug: string; name: string }>;
  size?: "sm" | "md";
}) {
  if (!tags?.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((t) => (
        <Link
          key={t.slug}
          to="/forum/tagg/$slug"
          params={{ slug: t.slug }}
          className={`inline-flex items-center rounded-full border border-border bg-secondary/60 font-semibold text-muted-foreground transition hover:border-accent hover:text-accent ${
            size === "md" ? "px-3 py-1 text-xs" : "px-2.5 py-0.5 text-[11px]"
          }`}
        >
          #{t.name}
        </Link>
      ))}
    </div>
  );
}
